import React, { useState } from 'react'
import { FormControl, FormLabel, Slider, SliderTrack, SliderFilledTrack, SliderThumb, Tooltip, Flex, Text } from '@chakra-ui/react'

export function SliderWithTooltip({ id, label, description, value, onChange, min = 0, max = 100, colorScheme = '#378BBF', isRequired = false }) {
  const [showTooltip, setShowTooltip] = useState(false)

  return (
    <FormControl>
      <Flex justify="space-between">
        <FormLabel htmlFor={id}>
          {label}{' '}
          {isRequired && (
            <Text as="span" color="red.500">
              *
            </Text>
          )}
        </FormLabel>
        <Text fontSize="sm" fontWeight="bold">
          {value}
        </Text>
      </Flex>

      {description && (
        <Text fontSize="xs" color="gray.500" mb={2}>
          {description}
        </Text>
      )}

      <Slider
        id={id}
        min={min}
        max={max}
        value={value}
        onChange={onChange}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <SliderTrack bg="gray.200">
          <SliderFilledTrack bg={colorScheme} />
        </SliderTrack>
        <Tooltip hasArrow bg={colorScheme} color="white" placement="top" isOpen={showTooltip} label={`${value}`}>
          <SliderThumb boxSize={6} bg={colorScheme} />
        </Tooltip>
      </Slider>
    </FormControl>
  )
}
